// deviceSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    device_id: '',
    manufacturer_name:'',
    initial_reading_day: '',
    initial_reading_month: '',
    initial_reading_year: '',
    assigned_day: '',
    assigned_month: '',
    assigned_year: '',
    model:'',
    serial_number:'',
    warranty_period:'',
    purchase_date_day:'',
    purchase_date_month:'',
    purchase_date_year:'',
    service_provider:'',
    service_period:'',
    service_activation_date_day:'',
    service_activation_date_month:'',
    service_activation_date_year:'',
    description:'',
    patient_id:'',
    device_id_inverse: '',
    manufacturer_name_inverse:'',
    initial_reading_day_inverse: '',
    initial_reading_month_inverse: '',
    initial_reading_year_inverse: '',
    assigned_day_inverse: '',
    assigned_month_inverse: '',
    assigned_year_inverse: '',
    model_inverse:'',
    serial_number_inverse:'',
    warranty_period_inverse:'',
    purchase_date_day_inverse:'',
    purchase_date_month_inverse:'',
    purchase_date_year_inverse:'',
    service_provider_inverse:'',
    service_period_inverse:'',
    service_activation_date_day_inverse:'',
    service_activation_date_month_inverse:'',
    service_activation_date_year_inverse:'',
    description_inverse:'',
    patient_id_inverse:'',
    purchase_date_inverse:'',
    service_activation_date_inverse:'',
    initial_reading_inverse:'',
    match: false,
    searchApplied: false,
};

const deviceSearchSlice = createSlice({
    name: 'deviceSearch',
    initialState,
    reducers: {
        setDeviceSearch(state, action) {
            return { ...state, ...action.payload }; // Only update the search criteria without changing `searchApplied`
        },
        resetDeviceSearch(state) {
            return { ...initialState, searchApplied: false }; // Reset state and flag
        },
        setSearchApplied(state) {
            state.searchApplied = true; // Directly set searchApplied to true
        },
        
    },
});

export const { setDeviceSearch, resetDeviceSearch, setSearchApplied } = deviceSearchSlice.actions;

export default deviceSearchSlice.reducer;